<template>
    <modal name="photo-details" @before-open="beforeOpen" @before-close="beforeClose"
        :classes="['v--modal', 'error-modal', 'photo']" :width="960" :height="'auto'" :scrollable="true" :adaptive="true">
        <div v-if="!instancesIsEmpty('details')">
            <div class="photo-main">
                <div class="photo-header">
                    <!-- <redirectButton
            v-if="instance.album"
            :pathname="getMethod()"
            :params="{
              profileId: instance.owner.id,
              albumId: instance.album.id,
            }"
            :html="instance.album.title"
            class="photo-album"
          ></redirectButton> -->
                    <redirectButton v-if="instance.album" :pathname="getMethod()" :params="{
                        profileId: instance.owner.id,
                        albumId: instance.album.id,
                    }" :html="getAlbumTitle(instance.album.title)" class="photo-album"></redirectButton>
                    <span @click="$modal.hide('photo-details')" class="photo-back"></span>
                    <div class="photo-total-count">
                        {{ current + 1 }}
                        {{ $t("photoDetails.from") }}
                        <span v-if="fromEvents">{{ eventCount }}</span>
                        <span v-else>{{ count }}</span>
                    </div>
                    <div v-if="instance.owner.id == user.id" class="photo-actions">
                        <span @click="
                            $modal.show('move-photos', {
                                instances: [instance],
                                isVideo: isVideo,
                            })
                            ">
                            {{ $t("photoDetails.move") }}
                        </span>
                        <span @click="removePhoto([instanceId], removeCallback)">
                            {{ $t("photoDetails.delete") }}
                        </span>
                    </div>
                </div>
                <div v-if="(!fromEvents && Object.keys(instances).length > 1) || eventCount > 1
                    ">
                    <button :disabled="!hasPrev" @click.prevent="showNext(prevId)" class="photo-arrow prev">
                        <div class="photo-arrow-front card-face">
                            <div class="photo-arrow-image" :style="{
                                'background-image': prevImage ? 'url(' + prevImage + ')' : '',
                            }"></div>
                            <CardFace :suit="suit" :rank="rank"></CardFace>
                        </div>
                        <div class="photo-arrow-back card-shirt"></div>
                    </button>
                    <button :disabled="!hasNext" @click.prevent="showNext(nextId)" class="photo-arrow next">
                        <div class="photo-arrow-front card-face">
                            <div class="photo-arrow-image" :style="{
                                'background-image': nextImage ? 'url(' + nextImage + ')' : '',
                            }"></div>
                            <CardFace :suit="suit" :rank="rank"></CardFace>
                        </div>
                        <div class="photo-arrow-back card-shirt"></div>
                    </button>
                </div>
                <div v-if="isVideo" ref="instance" class="photo-wrapper photo-wrapper-video">
                    <span v-if="instanceLoader">
                        {{ $t("photoDetails.loadingVideo") }}
                    </span>
                    <video v-else-if="instance.image" controls :poster="instance.image" :preload="metadata"
                        class="photo-video">
                        <source :src="instance.videos[1].video" :type="instance.videos[1].type" />
                        {{ $t("photoDetails.yourBrowserSupportHTML5Video") }}
                    </video>
                    <div v-else-if="instance.ready" class="photo-process">
                        {{ $t("photoDetails.videoProcessingError") }}
                    </div>
                    <div v-else class="photo-process">
                        {{ $t("photoDetails.videoProcessing") }}
                    </div>
                </div>
                <div v-else ref="instance" class="photo-wrapper" :class="{
                    'photo-wrapper-puzzle':
                        instance.owner.id != user.id && instance.album.album_type == 2,
                }">
                    <span v-if="instanceLoader">
                        {{ $t("photoDetails.uploadingPhoto") }}
                    </span>
                    <img v-else :src="instance.image" alt="" class="photo-img" />
                    <div v-if="instance.owner.id != user.id && instance.album.album_type == 2
                        " class="photo-buy">
                        <button @click="buy" :disabled="instance.bought" class="button">
                            <span v-if="instance.bought">
                                {{ $t("photoDetails.puzzlePurchased") }}
                            </span>
                            <span v-else>
                                {{ $t("photoDetails.buyPuzzle") }}
                            </span>
                        </button>
                        <div v-if="!userIsEmpty('user') && init.costs" class="photo-buy-prices">
                            <div class="photo-buy-price" :class="{ current: !user.vip }">
                                {{ $t("photoDetails.regularPrice") }}
                                {{ puzzlePrice }}
                                {{
                                    declineNouns(puzzlePrice, [
                                        $t("photoDetails.zarik"),
                                        $t("photoDetails.zarika"),
                                        $t("photoDetails.zarikov"),
                                    ])
                                }}
                            </div>
                            <div class="photo-buy-price vip" :class="{ current: user.vip }">
                                {{ $t("photoDetails.priceForVIP") }}
                                {{ vipPuzzlePrice }}
                                {{
                                    declineNouns(vipPuzzlePrice, [
                                        $t("photoDetails.zarik"),
                                        $t("photoDetails.zarika"),
                                        $t("photoDetails.zarikov"),
                                    ])
                                }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="photo-bottom">
                <div class="photo-info photo-bottom-item">
                    <div class="photo-info-row">
                        <div class="user-item" :class="{
                                    online: instance.owner.online,
                                }">
                            <router-link :to="'/profile/' + instance.owner.id" :style="{
                                'background-image': instance.owner.avatar
                                    ? 'url(' + instance.owner.avatar + ')'
                                    : '',
                            }" class="user-item-avatar" :class="{ 'no-avatar': !instance.owner.avatar }"></router-link>
                            <div class="user-item-info">
                                <router-link :to="'/profile/' + instance.owner.id" class="user-item-title">{{
                                    instance.owner.name }}</router-link>
                                <div class="user-item-bottom">
                                    {{ getVerbalDate(instance.time * 1000) }}
                                </div>
                            </div>
                        </div>
                        <div class="photo-votes">
                            <button v-if="voteLoader" class="photo-vote photo-vote-loader"></button>
                            <button v-else @click="vote(instanceId)" :disabled="instance.owner.id == user.id"
                                class="photo-vote" :class="{ 'photo-vote-liked': instance.liked }">
                                <SvgIcon name="like"></SvgIcon>
                            </button>
                            <div class="photo-votes-count">{{ instance.likes }}</div>
                        </div>
                    </div>
                    <div v-if="instance.owner.id != user.id && instance.description" class="photo-description">
                        <span class="photo-description-text">
                            {{ instance.description }}
                        </span>
                    </div>
                    <div v-else-if="instance.owner.id == user.id" class="photo-description"
                        :class="{ 'photo-description-disabled': descriptionLoader }">
                        <!-- <div @click="showEditButton = true" @input="checkDescLengthInput" wrap="hard" ref="pseudotextarea"
                            class="textarea" :class="{
                                empty: instance.description == '',
                                'textarea-video': isVideo,
                                showEditButton: showEditButton,
                            }" contenteditable="true">
                        </div> -->
                        <div @click="showEditButton = true" @input="checkDescLengthInput" wrap="hard" ref="pseudotextarea"
                            class="textarea"
                            :class="{ empty: instance.description == ' ', 'textarea-video': isVideo, showEditButton: showEditButton }"
                            :data-placeholder="isVideo ? placeholderVideoText : placeholderText" contenteditable="true">
                        </div>
                        <div v-if="showEditButton" class="buttons-row photo-description-buttons">
                            <button @click="cancelEdit" class="button-secondary">
                                {{ $t("photoDetails.cancel") }}
                            </button>
                            <button @click="editDescription(instanceId)" class="button">
                                {{ $t("photoDetails.save") }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="photo-comments photo-bottom-item">
                    <div v-if="commentsLoader" class="photo-comments-form vip-only desktop">
                        <button class="button-loader"></button>
                    </div>
                    <div v-else-if="instance.owner.vip_settings.comments == 1 &&
                        !user.vip &&
                        instance.owner.is_friend.type != 2
                        " class="photo-comments-form vip-only desktop">
                        {{ $t("photoDetails.onlyFriendsVIPsCanComment") }}
                    </div>
                    <div v-else class="photo-comments-form desktop">
                        <textarea @focus="checkCommentForm" v-model="text" v-validate.persist="'required'" wrap="hard"
                            class="textarea" :class="{ open: showCommentForm }" id="text" type="text"
                            name="text"></textarea>
                        <div v-if="showCommentForm" class="buttons-row">
                            <button @click="
                                showCommentForm = false;
                            text = '';
                            " class="button-secondary">
                                {{ $t("photoDetails.cancel") }}
                            </button>
                            <button v-if="commentLoader" class="button button-loader"></button>
                            <button v-else @click="addComment" class="button">
                                {{ $t("photoDetails.send") }}
                            </button>
                        </div>
                    </div>
                    <div v-if="!commentsIsEmpty('comments')" class="photo-comments-wrapper">
                        <div ref="vBar" class="photo-comments-scrollbar-container">
                            <div class="photo-comments-inner">
                                <div v-for="(comment, index) in comments" :ref="'element' + index"
                                    class="info-block user-item photo-comments-item">
                                    <router-link :to="'/profile/' + comment.owner.id" :style="{
                                        'background-image': comment.owner.avatar
                                            ? 'url(' + comment.owner.avatar + ')'
                                            : '',
                                    }" class="user-item-avatar"
                                        :class="{ 'no-avatar': !comment.owner.avatar }"></router-link>
                                    <div class="user-item-info">
                                        <router-link :to="'/profile/' + comment.owner.id" class="user-item-title">{{
                                            comment.owner.name }}</router-link>
                                        <div class="user-item-subtitle">{{ comment.text }}</div>
                                        <div class="user-item-bottom">
                                            {{ getVerbalDate(comment.time * 1000) }}
                                        </div>
                                    </div>
                                    <div class="user-item-right">
                                        <button v-if="deleteLoader" class="delete delete-loader"></button>
                                        <button v-else-if="comment.owner.id == user.id ||
                                            instance.owner.id == user.id
                                            " @click="deleteComment(comment.id)" class="delete"></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="photo-comments-wrapper">
                        <div class="photo-comments-inner photo-comments-empty">
                            {{ $t("photoDetails.noCommentsYet") }}
                        </div>
                    </div>
                    <div v-if="moreCommentsLoader">
                        <button class="button-loader"></button>
                    </div>

                    <div v-if="commentsLoader" class="photo-comments-form vip-only mobile">
                        <button class="button-loader"></button>
                    </div>
                    <div v-else-if="instance.owner.vip_settings.comments == 1 &&
                        !user.vip &&
                        instance.owner.is_friend.type != 2
                        " class="photo-comments-form vip-only mobile">
                        {{ $t("photoDetails.onlyFriendsVIPsCanComment") }}
                    </div>
                    <div v-else class="photo-comments-form mobile">
                        <textarea v-model="text" v-validate="'required'" class="textarea" id="text" type="text"
                            name="text"></textarea>
                        <button v-if="commentLoader" class="button button-loader"></button>
                        <button v-else @click="addComment" class="button"></button>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div v-else-if="instanceErrors" class="photo-main photo-main-load"><span>Фото удалено или недоступно.</span></div> -->
        <div v-else class="photo-main photo-main-load">
            <span>{{ $t("loading.loading") }}</span>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from "vuex";
import { formatDateTime } from "@/mixins/formatDateTime";
import { randomInteger } from "@/mixins/randomInteger";
import { removePhoto } from "@/mixins/removePhoto";
import { observeListEnd } from "@/mixins/observeListEnd";
import { handleSwipe } from "@/mixins/handleSwipe";
import { checkScroll } from "@/mixins/checkScroll";
import redirectButton from "@/components/Buttons/Redirect";
import CardFace from "@/components/Blocks/CardFace";
import SvgIcon from "@/components/SvgSprite";
import { consts } from "@/consts";
import Vue from "vue";

export default {
    name: "PhotoDetails",
    props: {
        i18n: Object,
    },
    components: {
        redirectButton,
        CardFace,
        SvgIcon,
    },
    mixins: [
        formatDateTime,
        randomInteger,
        removePhoto,
        observeListEnd,
        handleSwipe,
        checkScroll,
    ],
    data() {
        return {
            placeholderText: this.$t('upload.photoDescription'),
            placeholderVideoText: this.$t('upload.videoDescription'),
            feed: false,
            instanceLoader: true,
            commentsLoader: true,
            hasBugs: false,
            instanceId: "",
            albumId: "",
            text: "",
            current: "",
            nextId: "",
            nextImage: "",
            prevId: "",
            prevImage: "",
            newAlbumTitle: "",
            fromEvents: false,
            hasNext: true,
            hasPrev: true,
            eventCount: null,
            eventArr: null,
            ranks: consts.card_ranks,
            suit: 1,
            rank: 7,
            voteLoader: false,
            localDescription: "",
            showCommentForm: false,
            showEditButton: false,
            commentLoader: false,
            moreCommentsLoader: false,
            deleteLoader: false,
            vipOnly: false,
            descriptionLoader: false,
            moreIndex: 0,
            observer: null,
            swipe: false,
            descMaxLength: 150,
            lastText: undefined,
            lastOffset: undefined,
            valueSetter: "",
            value: "",
            isVideo: false,

            prevDescription: "",
        };
    },
    computed: {
        ...mapGetters({
            init: "init/fetchInit",
            initIsEmpty: "init/isEmpty",
            user: "user/fetchUser",
            userIsEmpty: "user/isEmpty",
            bought: "puzzles/fetchBought",
            // comments: 'videoComments/fetchVideoComments',
            // comments: 'comments/fetchComments',
            // commentsErrors: 'comments/errors',
            // commentsIsEmpty: 'comments/isEmpty',
            // nextComments: 'comments/fetchCommentsNext',
        }),
        instance() {
            return this.$store.getters[
                this.getMethod() +
                "/fetch" +
                this.getMethod(true, "", false) +
                "Details"
            ];
        },
        instances() {
            return this.$store.getters[
                this.getMethod() + "/fetch" + this.getMethod(true)
            ];
        },
        instancesIsEmpty() {
            return this.$store.getters[this.getMethod() + "/isEmpty"];
        },
        instanceErrors() {
            return this.$store.getters[this.getMethod() + "/errors"];
        },
        newAlbum() {
            return this.$store.getters[
                this.getAlbumMethod() +
                "/fetchNew" +
                this.getMethod(true, "", false) +
                "Album"
            ];
        },
        count() {
            return this.$store.getters[
                this.getMethod() + "/fetch" + this.getMethod(true) + "Count"
            ];
        },
        albumIsUpdated() {
            return this.$store.getters[
                this.getMethod() +
                "/fetch" +
                this.getMethod(true, "", false) +
                "IsUpdated"
            ];
        },
        comments() {
            return this.$store.getters[
                this.getCommentsMethod() +
                "/fetch" +
                this.getMethod(true, "", false) +
                "Comments"
            ];
        },
        commentsErrors() {
            return this.$store.getters[this.getCommentsMethod() + "/errors"];
        },
        commentsIsEmpty() {
            return this.$store.getters[this.getCommentsMethod() + "/isEmpty"];
        },
        nextComments() {
            return this.$store.getters[
                this.getCommentsMethod() +
                "/fetch" +
                this.getMethod(true, "", false) +
                "CommentsNext"
            ];
        },
        puzzlePrice() {
            return this.formatPrice(this.init.costs.puzzle_price);
        },
        vipPuzzlePrice() {
            return Math.ceil(
                (this.init.costs.puzzle_price * (100 - this.init.costs.vip_discount)) /
                100
            );
        },
    },
    watch: {
        $route(to, from) {
            if (to != from) {
                this.$modal.hide("photo-details");
            }
        },
        albumIsUpdated() {
            if (this.albumIsUpdated) {
                this.$store.dispatch(
                    this.getMethod(false, "/getDetails"),
                    this.instanceId
                );
            }
        },
    },
    methods: {
        getAlbumTitle(title) {
            return title === 'Общий' ? this.$t('albums.general') : title;
        },
        getMethod(capitalize = false, method = "", isPlural = true) {
            let str = this.isVideo ? "video" : "photo";
            if (capitalize) str = str.charAt(0).toUpperCase() + str.slice(1);
            if (isPlural) str += "s";
            return str + method;
        },
        getAlbumMethod(method = "") {
            return (this.isVideo ? "videoAlbums" : "albums") + method;
        },
        getCommentsMethod(method = "") {
            return (this.isVideo ? "videoComments" : "comments") + method;
        },
        beforeOpen(event) {
            // Защита от undefined params
            if (!event || !event.params) {
                console.error('PhotoDetails: event.params is undefined');
                return;
            }
            
            this.feed = event.params.feed || false;
            this.isVideo = event.params.isVideo || false;
            this.checkScroll();
            this.fromEvents = false;
            this.instanceId = event.params.id;
            this.initInstance();
            if (event.params.fromEvents) {
                this.fromEvents = true;
                this.eventArr = event.params.eventArr || null;
                if (this.eventArr) {
                    this.calcPrevNext();
                } else {
                    this.current = 0;
                    this.eventCount = 1;
                }
            } else if (this.feed) {
                this.current = 0;
                this.eventCount = 1;
            } else {
                this.calcPrevNext();
            }
            if (event.params.isAlbum) {
                this.$store.dispatch(this.getMethod(false, "/setIsAlbum"), true);
            }
        },
        beforeClose() {
            this.checkRemoveScroll();
            this.$store.dispatch(this.getMethod(false, "/setIsAlbum"), false);
            this.swipe = false;
        },
        initInstance() {
            this.instanceLoader = true;
            this.commentsLoader = true;
            this.nextId = "";
            this.prevId = "";
            this.getInstance();
            this.getComments();
            this.rank = this.ranks[this.randomInteger(0, 8)];
            this.suit = this.randomInteger(1, 4);
            this.observer = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting === true) {
                        this.showMoreComments();
                    }
                },
                { threshold: [0] }
            );
        },
        getInstance() {
            this.$store
                .dispatch(this.getMethod(false, "/getDetails"), this.instanceId)
                .then(() => {
                    this.instanceLoader = false;
                    this.localDescription = this.instance.description;
                    this.commentsLoader = false;

                    if (this.instance.owner.id == this.user.id) {
                        let msie = window.document.documentMode;
                        setTimeout(() => {
                            this.$refs.pseudotextarea.innerText = this.instance.description;
                            let textarea = this.$refs.pseudotextarea;
                            if (msie) {
                                textarea.addEventListener("keydown", this.onKeydown);
                            } else {
                                textarea.addEventListener("input", this.onKeydown);
                            }
                        }, 500);
                    }

                    if (this.swipe) {
                        return;
                    }
                    this.initSwipe();
                })
                .catch(() => {
                    this.instanceLoader = false;
                    this.commentsLoader = false;
                    this.$modal.hide("photo-details");
                    let text =
                        this.instanceErrors && this.instanceErrors.vip_settings == 1
                            ? this.getText() + this.$t("photoDetails.noCommentsYetVip")
                            : this.getText() + this.$t("photoDetails.deletedUnavailable");
                    this.$modal.show("dialog", {
                        title: this.$t("login.error"),
                        text: text,
                        buttons: [{ title: this.$t("roulette.ok") }],
                    });
                });
        },
        getText() {
            return this.isVideo
                ? this.$t("photoDetails.video")
                : this.$t("photoDetails.photo");
        },
        calcPrevNext() {
            if (this.count == 1 || this.feed) {
                this.current = 0;
                return;
            }
            let arr = [];
            let instancesArr = this.fromEvents ? this.eventArr : this.instances;
            this.eventCount = this.eventArr ? this.eventArr.length : null;
            for (let i in instancesArr) {
                arr.push(instancesArr[i].id);
            }

            let calcCurrent = () => {
                for (let j in this.instances) {
                    if (this.instances[j].id == this.instanceId) {
                        return parseInt(j);
                    }
                }
            };

            this.current = this.fromEvents
                ? arr.indexOf(this.instanceId)
                : calcCurrent();

            let calcPrevId = () => {
                if (this.current > 0) {
                    this.prevId = this.instances[this.current - 1].id;
                    this.prevImage = this.instances[this.current - 1].image;
                } else {
                    this.prevId = this.instances[this.count - 1].id;
                    this.prevImage = this.instances[this.count - 1].image;
                }
            };

            let calcNextIdImage = () => {
                if (this.current < this.count - 1) {
                    this.nextId = this.instances[this.current + 1].id;
                    this.nextImage = this.instances[this.current + 1].image;
                } else {
                    this.nextId = this.instances[0].id;
                    this.nextImage = this.instances[0].image;
                }
            };

            if (!this.fromEvents) {
                let prevCheck =
                    this.current >= 2 ? this.current - 2 : this.count + this.current - 2;

                let nextCheck =
                    this.current < this.count - 2
                        ? this.current + 2
                        : this.current - this.count + 2;

                if (!this.instances[prevCheck]) {
                    this.hasPrev = false;
                    this.$store.dispatch(this.getMethod(false, "/getPrev")).then(() => {
                        this.hasPrev = true;
                        calcPrevId();
                    });
                } else {
                    calcPrevId();
                }

                if (!this.instances[nextCheck]) {
                    this.hasNext = false;
                    this.$store.dispatch(this.getMethod(false, "/getNext")).then(() => {
                        calcNextIdImage();
                        this.hasNext = true;
                    });
                } else {
                    calcNextIdImage();
                }
            } else {
                this.nextId =
                    this.current < arr.length - 1 ? arr[this.current + 1] : arr[0];

                this.nextImage =
                    this.current < arr.length - 1
                        ? instancesArr[this.current + 1].image
                        : instancesArr[0].image;

                this.prevId =
                    this.current > 0 ? arr[this.current - 1] : arr[arr.length - 1];

                this.prevImage =
                    this.current > 0
                        ? arr[this.current - 1].image
                        : arr[arr.length - 1].image;
            }
        },
        initSwipe() {
            let self = this;
            this.handleSwipe(
                this.$refs.instance,
                function () {
                    return self.checkNext(true);
                },
                function () {
                    return self.checkNext(false);
                }
            );
            this.swipe = true;
        },
        getComments() {
            this.$store
                .dispatch(this.getCommentsMethod("/get"), this.instanceId)
                .then(() => {
                    this.updateMoreIndex();
                    this.observeListEnd("element");
                    if (this.commentsIsEmpty("comments")) {
                        return;
                    }
                    setTimeout(() => {
                        this.$vuebar.initScrollbar(this.$refs.vBar, {});
                    }, 500);
                });
        },
        vote(id) {
            if (this.userIsEmpty("user")) {
                this.$modal.hide("photo-details");
                this.$modal.show("welcome");
                return;
            }
            this.voteLoader = true;
            this.$store
                .dispatch(this.getMethod(false, "/like"), id)
                .then(() => {
                    this.voteLoader = false;
                })
                .catch(() => {
                    this.voteLoader = false;
                });
        },
        addComment() {
            this.$validator.validateAll().then((valid) => {
                if (valid) {
                    this.commentLoader = true;
                    const data = { text: this.text };
                    data[this.getMethod(false, "", false)] = this.instanceId;
                    this.$store
                        .dispatch(this.getCommentsMethod("/add"), data)
                        .then(() => {
                            this.text = "";
                            this.errors.clear();
                            this.$validator.reset();
                            this.showCommentForm = false;
                            this.commentLoader = false;
                            if (this.$vuebar.getState(this.$refs.vBar)) {
                                return;
                            }
                            setTimeout(() => {
                                this.$vuebar.initScrollbar(this.$refs.vBar, {});
                            }, 500);
                        })
                        .catch(() => {
                            if (this.commentsErrors.vip_settings) {
                                this.text = "";
                                this.errors.clear();
                                this.$validator.reset();
                                this.showCommentForm = false;
                                this.$modal.show("dialog", {
                                    title: this.$t("login.error"),
                                    text: this.$t(
                                        "photoDetails.addingCommentsAvailableFriendsVIPs"
                                    ),
                                    buttons: [
                                        {
                                            title: this.$t("roulette.ok"),
                                        },
                                    ],
                                });
                            }
                            this.commentLoader = false;
                        });
                }
            });
        },
        deleteComment(id) {
            this.deleteLoader = true;
            this.$store
                .dispatch(this.getCommentsMethod("/remove"), id)
                .then(() => {
                    this.deleteLoader = false;
                })
                .catch(() => {
                    this.deleteLoader = false;
                });
        },
        checkDescLengthInput(e) {
            let text = this.$refs.pseudotextarea.textContent;
            let selection = window.getSelection();
            let { anchorNode, anchorOffset } = selection;
            anchorOffset = Math.min(anchorOffset, this.descMaxLength);
            if (text.length > this.descMaxLength) {
                if (e.inputType == "insertFromPaste") {
                    text = text.slice(0, this.descMaxLength);
                } else {
                    text = this.lastText || text.slice(0, this.descMaxLength);
                }
                this.$refs.pseudotextarea.textContent = text;
                selection.collapse(anchorNode, this.lastOffset);
                this.placeCaretAtEnd(this.$refs.pseudotextarea);
                return;
            }
            this.lastText = text;
            this.lastOffset = anchorOffset;
            this.$emit("input", text);
        },
        placeCaretAtEnd(el) {
            el.focus();
            if (
                typeof window.getSelection != "undefined" &&
                typeof document.createRange != "undefined"
            ) {
                let range = document.createRange();
                range.selectNodeContents(el);
                range.collapse(false);
                let sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
            } else if (typeof document.body.createTextRange != "undefined") {
                let textRange = document.body.createTextRange();
                textRange.moveToElementText(el);
                textRange.collapse(false);
                textRange.select();
            }
        },
        editDescription(id) {
            this.showEditButton = false;
            if (this.instance.description == this.localDescription) {
                return;
            }
            this.descriptionLoader = true;
            const data = [
                {
                    id: id,
                    album: this.instance.album.id,
                    description: this.instance.description,
                },
            ];
            this.$store
                .dispatch(this.getMethod(false, "/updateDescription"), data)
                .then(() => {
                    this.localDescription = this.instance.description;
                    this.descriptionLoader = false;
                })
                .catch(() => {
                    this.descriptionLoader = false;
                });
        },

        cancelEdit() {
            const textarea = this.$refs.pseudotextarea;
            const newDescription = textarea.innerText;
            if (newDescription !== this.prevDescription) {
                const diffIndex =
                    newDescription.indexOf(this.prevDescription) +
                    this.prevDescription.length;
                textarea.innerText = newDescription.slice(0, diffIndex);
            }
            this.showEditButton = false;
        },

        removeCallback() {
            if (this.fromEvents) {
                this.$store.dispatch("events/get", "");
            }
            setTimeout(() => {
                this.$modal.hide("photo-details");
            }, 100);
        },
        checkNext(forward) {
            const id = () => {
                return forward ? this.nextId : this.prevId;
            };
            if (id()) {
                this.showNext(id());
            } else {
                this.instanceLoader = true;
                let promise = new Promise((resolve, reject) => {
                    let count = 0;
                    let checkId = () => {
                        setTimeout(() => {
                            if (id()) {
                                resolve();
                            } else if (count < 20) {
                                count++;
                                checkId();
                            } else {
                                reject();
                            }
                        }, 100);
                    };
                    checkId();
                });

                promise
                    .then(() => {
                        this.instanceLoader = false;
                        this.showNext(id());
                    })
                    .catch(() => {
                        this.instanceLoader = false;
                    });
            }
        },
        showNext(id) {
            if (this.$refs.vBar) {
                this.$vuebar.destroyScrollbar(this.$refs.vBar);
            }
            this.instanceId = id;
            this.initInstance();
            this.calcPrevNext();
        },
        updateMoreIndex() {
            this.moreIndex = this.comments.length - 2;
        },
        showMoreComments() {
            if (this.nextComments) {
                this.moreCommentsLoader = true;
                this.$store
                    .dispatch(this.getCommentsMethod("/getNext"))
                    .then(() => {
                        this.observeListEnd("element", false, true, true);
                        this.moreCommentsLoader = false;
                    })
                    .catch(() => {
                        this.moreCommentsLoader = false;
                    });
            } else {
                this.observeListEnd("element", false, true);
            }
        },
        onKeydown(e) {
            let self = this;
            setTimeout(function () {
                self.onInput.call(this, e);
            });
        },
        onInput(e) {
            let trim = e.target.textContent.trim();
            let value = e.target.innerText;
            if (e.target.lastValue == trim) {
                return;
            }
            e.target.lastValue = trim;
            this.instance.description = value;
        },
        buy() {
            if (this.userIsEmpty("user")) {
                this.$modal.hide("photo-details");
                this.$modal.show("welcome");
                return;
            }
            let currPrice = this.user.vip ? this.vipPuzzlePrice : this.puzzlePrice;
            if (parseFloat(currPrice) > parseFloat(this.user.balance)) {
                this.$modal.show("dialog", {
                    title: this.$t("photoDetails.insufficientFunds"),
                    text: this.$t("photoDetails.notEnoughMoneyBuyPuzzle"),
                    buttons: [
                        {
                            title: this.$t("photoDetails.replenishBalance"),
                            handler: () => {
                                this.$modal.hide("dialog");
                                this.$modal.show("balance-in");
                            },
                        },
                        {
                            title: this.$t("photoDetails.close"),
                        },
                    ],
                });
                return;
            }
            this.$store.dispatch("puzzles/buy", this.instanceId).then(() => {
                this.instance.bought = true;
                this.$modal.hide("photo-details");
                this.$modal.show("puzzle", { photoId: this.instanceId });
            });
        },
        formatPrice(price) {
            let arr = price.split(".");
            return arr[1] == "00" ? arr[0] : price;
        },
        checkCommentForm() {
            if (this.userIsEmpty("user")) {
                this.$modal.hide("photo-details");
                this.$modal.show("welcome");
            } else {
                this.showCommentForm = true;
            }
        },
    },
    mounted() {
        const textarea = this.$refs.pseudotextarea;
        this.prevDescription = textarea ? textarea.innerText : (this.instance.description || "");
    },
    //   mounted() {
    //     this.prevDescription = this.$refs.pseudotextarea.innerText.trim();
    //   },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_playing-card";
</style>
